var map = {
	"./n_failed_proposals.svg": 6446,
	"./n_parts.svg": 1181,
	"./n_praises.svg": 6452,
	"./n_proposals.svg": 7038,
	"./n_stories.svg": 740,
	"./n_tokens.svg": 9595,
	"./n_unique_words.svg": 1574,
	"./n_votes.svg": 7184,
	"./n_winning_votes.svg": 3949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9755;